'use client';
import type { Assign } from '@ark-ui/react';
import { FileUpload } from '@ark-ui/react';
import {
  type FileUploadVariantProps,
  fileUpload,
} from '@terra/ui-styled-system';
import type { ComponentProps, HTMLStyledProps } from '@terra/ui-styled-system';
import { createStyleContext } from './utils/create-style-context';

const { withProvider, withContext } = createStyleContext(fileUpload);

export type RootProviderProps = ComponentProps<typeof RootProvider>;
export const RootProvider = withProvider<
  HTMLDivElement,
  Assign<
    Assign<HTMLStyledProps<'div'>, FileUpload.RootProviderProps>,
    FileUploadVariantProps
  >
>(FileUpload.RootProvider, 'root');

export type RootProps = ComponentProps<typeof Root>;
export const Root = withProvider<
  HTMLDivElement,
  Assign<
    Assign<HTMLStyledProps<'div'>, FileUpload.RootProps>,
    FileUploadVariantProps
  >
>(FileUpload.Root, 'root');

export const Dropzone = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, FileUpload.DropzoneProps>
>(FileUpload.Dropzone, 'dropzone');

export const ItemDeleteTrigger = withContext<
  HTMLButtonElement,
  Assign<HTMLStyledProps<'button'>, FileUpload.ItemDeleteTriggerProps>
>(FileUpload.ItemDeleteTrigger, 'itemDeleteTrigger');

export const ItemGroup = withContext<
  HTMLUListElement,
  Assign<HTMLStyledProps<'ul'>, FileUpload.ItemGroupProps>
>(FileUpload.ItemGroup, 'itemGroup');

export const ItemName = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, FileUpload.ItemNameProps>
>(FileUpload.ItemName, 'itemName');

export const ItemPreviewImage = withContext<
  HTMLImageElement,
  Assign<HTMLStyledProps<'img'>, FileUpload.ItemPreviewImageProps>
>(FileUpload.ItemPreviewImage, 'itemPreviewImage');

export const ItemPreview = withContext<
  HTMLImageElement,
  Assign<HTMLStyledProps<'div'>, FileUpload.ItemPreviewProps>
>(FileUpload.ItemPreview, 'itemPreview');

export const Item = withContext<
  HTMLLIElement,
  Assign<HTMLStyledProps<'li'>, FileUpload.ItemProps>
>(FileUpload.Item, 'item');

export const ItemSizeText = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, FileUpload.ItemSizeTextProps>
>(FileUpload.ItemSizeText, 'itemSizeText');

export const Label = withContext<
  HTMLLabelElement,
  Assign<HTMLStyledProps<'label'>, FileUpload.LabelProps>
>(FileUpload.Label, 'label');

export const Trigger = withContext<
  HTMLButtonElement,
  Assign<HTMLStyledProps<'button'>, FileUpload.TriggerProps>
>(FileUpload.Trigger, 'trigger');

export {
  FileUploadContext as Context,
  FileUploadHiddenInput as HiddenInput,
} from '@ark-ui/react';
